import { DropDown } from 'components/inputBox/inputBox';
import './annualLeaveModification.scss';
import NavBar from './navbar/navBar';
import CustomInputAnnualLeave from './customInputAnnualLeave/customInputAnnualLeaave';
const AnnualLeaveModification = () => {
  return (
    <div className="annualLeaveModificationComponent">
      <NavBar />
      <div className="container">
        <div className="breadCrumb">
          <div className="mainScreen">직원목록</div> {'>'}
          <div className="secondScreen">근무일정</div>
        </div>

        <div className="nameContainer">
          <div className="image">길동</div>
          <div className="nameText">홍길동</div>
        </div>

        <div className="cardContainer">
          <div className="leftContainer">
            <div className="title">연차정보 </div>

            <DropDown options={['2022']} label="적용년도" />

            <div className="leaveRow">
              <div className="wrapper">
                <CustomInputAnnualLeave title="총 연차" placeHolder="총 연차 수  입력" />
              </div>
              <div className="wrapper">
                <CustomInputAnnualLeave title="사용 연차" placeHolder="사용 연차 수 입력" />
              </div>
              <div className="wrapper">
                <CustomInputAnnualLeave title="남은 연차" placeHolder="남은 연차 수 입력" />
              </div>
            </div>
          </div>

          <div className="rightContainer">
            <div className="title">일정템플릿이란?</div>
            <div className="description">여기에는 내용이 들어갑니다.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnualLeaveModification;
